<script setup lang="ts">
import { NxtFormSection, NxtToggle } from '@future-harry/nxt-styles';
import { JobBoard } from '@/core/collections/job-boards/job-board.interface';
import GeneralFormSection from '@/apps/admin/components/forms/settings/GeneralFormSection.vue';
import MetadataFormSection from '@/apps/admin/components/forms/settings/MetadataFormSection.vue';
import GeneralMediaFormSection from '@/apps/admin/components/forms/settings/GeneralMediaFormSection.vue';

const jobBoard = defineModel<JobBoard>('modelValue', { required: true });

defineProps({
   isMediaSectionEnabled: {
      type: Boolean,
      default: true,
   },
});
</script>

<template>
   <div>
      <NxtFormSection :title="$t('job-board.settings.general')">
         <template #actions>
            <NxtToggle v-model="jobBoard.is_published" :name="`settings_is_published`" :label="$t('job-board.settings.is_published')" />
         </template>
         <GeneralFormSection v-model="jobBoard" />
      </NxtFormSection>

      <NxtFormSection v-if="isMediaSectionEnabled" :title="$t('job-board.settings.media')">
         <GeneralMediaFormSection v-model="jobBoard" />
      </NxtFormSection>

      <NxtFormSection :title="$t('job-board.settings.meta_data.meta_data')">
         <MetadataFormSection v-model="jobBoard" />
      </NxtFormSection>
   </div>
</template>
